
import { Component, Prop, Vue } from 'vue-property-decorator';
import Dashboard from '@/components/Dashboard.vue';
import { TemplateReportList } from '@/collections/template_reports';
import { MeasureList } from '@/collections/measures';
import { StoreModel } from '@/models/store';

@Component({
  components: {
    Dashboard,
  },
})
export default class MyDashboard extends Vue {
  @Prop({ default: () => new StoreModel() })
  public store!: StoreModel;
  @Prop({ default: false })
  public enableAthena!: boolean;
  @Prop({ default: false })
  public isDataReady!: boolean;
  @Prop({ default: false })
  public isAthenaReady!: boolean;
  @Prop({ default: false })
  public isAthenaFinished!: boolean;
  @Prop({ default: () => [] })
  public timeRangeLimit!: string[];
  @Prop({ default: 'available' })
  public isLockedReports!: string;
  @Prop({ default: false })
  public hasSchemas!: boolean;
  @Prop({ default: () => new TemplateReportList() })
  public templateReports!: TemplateReportList;
  @Prop({ default: () => new MeasureList() })
  public measures!: MeasureList;

  // Error state properties
  private loading = false;
  private dashboardNotFound = false;
  private errorMessage = '';
  private hasError = false;
  private dashboardModel: any = null;

  async created() {
    await this.loadDashboard();
  }

  private async loadDashboard() {
    this.loading = true;
    // Reset error states
    this.dashboardNotFound = false;
    this.hasError = false;
    this.errorMessage = '';
    
    try {
      const dashboardId = this.$route.params.dashboard_id;
      if (!dashboardId) {
        throw new Error('Dashboard ID is required');
      }

      // Import DashboardModel here to avoid circular dependencies
      const { DashboardModel } = await import('@/models/dashboard');
      this.dashboardModel = new DashboardModel({ id: parseInt(dashboardId, 10) });
      await this.dashboardModel.fetch();
      
      // Check if dashboard was actually loaded
      if (!this.dashboardModel.id) {
        this.dashboardNotFound = true;
        return;
      }
      
    } catch (error: any) {
      console.error('Error loading dashboard:', error);
      
      // Check if it's a 404 error (dashboard not found)
      if (error?.response?.status === 404 || error?.status === 404) {
        this.dashboardNotFound = true;
      } else {
        this.hasError = true;
        this.errorMessage = error?.message || 'Failed to load dashboard';
      }
    } finally {
      this.loading = false;
    }
  }
}
